export const semester = [
    { key: 'ganjil', value: 'Ganjil' },
    { key: 'genap', value: 'Genap' },
]

export const status = [
    { key: '0', value: 'Non-Aktif' },
    { key: '1', value: 'Aktif' },
]


// WEBPACK FOOTER //
// ./src/constants/tahunAjar.js